<template>
    <div class="footer">2021 &copy; Can Özsoy</div>
</template>

<script>
export default {
    name: "FooterComponent"
}
</script>

<style lang="scss" scoped>
.footer {
    flex: 0;
    padding: 20px;
    font-size: 20px;
}
</style>